export default __webpack_public_path__ + "images/d36dc39294a29be48514551016ed3fef-spotify_logo@2x.png";